import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import api,{ handleApiError }  from "../../helpers/api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Widgets = () => {
    const [stats, setStats] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await api.get("/dashboard/stats");
                const data = res.data;

                const widgets = [
                    {
                        label: "Total Products",
                        counter: data.products?.value || 0,
                        percentage: data.products?.trend || 0,
                        badge: data.products?.trend >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line",
                        badgeClass: data.products?.trend >= 0 ? "success" : "danger",
                        link: "/apps-ecommerce-products",
                        bgcolor: "primary",
                        icon: "ri-shopping-bag-line",
                    },
                    {
                        label: "Total Clients",
                        counter: data.users?.value || 0,
                        percentage: data.users?.trend || 0,
                        badge: data.users?.trend >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line",
                        badgeClass: data.users?.trend >= 0 ? "success" : "danger",
                        link: "/apps-ecommerce-clients",
                        bgcolor: "info",
                        icon: "ri-user-3-line",
                    },
                    {
                        label: "Total Orders",
                        counter: data.orders?.value || 0,
                        percentage: data.orders?.trend || 0,
                        badge: data.orders?.trend >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line",
                        badgeClass: data.orders?.trend >= 0 ? "success" : "danger",
                        link: "/apps-ecommerce-orders",
                        bgcolor: "warning",
                        icon: "ri-shopping-cart-2-line",
                    },
                    {
                        label: "Job Applications",
                        counter: data.applications?.value || 0,
                        percentage: data.applications?.trend || 0,
                        badge: data.applications?.trend >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line",
                        badgeClass: data.applications?.trend >= 0 ? "success" : "danger",
                        link: "/apps-job-lists",
                        bgcolor: "success",
                        icon: "ri-briefcase-line",
                    },
                ];

                setStats(widgets);
            } catch (err) {
                handleApiError(err, dispatch, navigate);
            }
        };

        fetchStats();
    }, [dispatch, navigate]);

    return (
        <Row>
            {stats.map((item, key) => (
                <Col xl={3} md={6} key={key}>
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">{item.label}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <h5 className={`fs-14 mb-0 text-${item.badgeClass}`}>
                                        {item.badge && <i className={`fs-13 align-middle ${item.badge}`}></i>} {item.percentage} %
                                    </h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                        <CountUp start={0} end={item.counter} duration={3} separator="," />
                                    </h4>
                                    <Link to={item.link} className="text-decoration-underline">
                                        More Details
                                    </Link>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                  <span className={`avatar-title rounded fs-3 bg-${item.bgcolor}`}>
                    <i className={item.icon}></i>
                  </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default Widgets;